<template>
  <main>

    <app-draw-feature 
      @drawend="onDrawEnd"
      :map="map" :active="isActive" :drawing="isDrawing" :mode="mode"></app-draw-feature>

    <v-navigation-drawer app disable-resize-watcher hide-overlay mobile-break-point="0" :value="isActive">
      <v-container fluid class="pa-0">
        <v-layout row>
          <v-flex xs12>
            <v-toolbar flat extension-height="300">
              <v-toolbar-title>
                {{ $t('poligonos-de-busqueda') }}
              </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$store.dispatch('disableControl')">
                  <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
          </v-flex>
        </v-layout>
      </v-container>

      <app-select-draw-mode
        ref="drawModeSelector" 
        @change-draw-mode="onDrawModeChange"
        poligono rectangulo defaultMode="Polygon"></app-select-draw-mode>

      <v-scale-transition>
        <v-alert :value="true" type="info" color="green" class="mt-0">
          {{ $t('poligonos-de-busqueda-hint') }}
        </v-alert>
      </v-scale-transition>

      <!-- <v-container v-if="!feature" fluid>
        <v-layout row wrap style="justify-content: space-around;">
          <v-tooltip bottom>
            <v-btn slot="activator" round color="green" @click="drawPolygon" :disabled="isDrawing">
              <vector-polygon-icon style="font-size: 22px;"></vector-polygon-icon>
            </v-btn>
            <span>{{ $t('poligono') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <v-btn slot="activator" round color="green" @click="drawRectangle" :disabled="isDrawing">
              <vector-rectangle-icon style="font-size: 22px;"></vector-rectangle-icon>
            </v-btn>
            <span>{{ $t('rectangulo') }}</span>
          </v-tooltip>
        </v-layout>
      </v-container> -->

      <v-divider v-if="feature"></v-divider>

      <v-container v-show="feature" fluid>
        <v-layout row wrap>
          <v-text-field 
            ref="polyname"
            v-model="featureName" :label="$t('nombre-poligono')" 
            :rules="[
              str => str ? true : $t('errores.rellena-nombre'),
              str => !this.polygons.find(p => p.name == str) ? true : $t('errores.poligono-repetido')
            ]"
          ></v-text-field>
        </v-layout>
        <v-layout row wrap>
          <v-btn @click="savePolygon" block :disabled="formHasErrors">{{ $t('guardar-poligono') }}</v-btn>
        </v-layout>
        <v-layout row wrap>
          <v-btn @click="discardPolygon" block>{{ $t('descartar-poligono') }}</v-btn>
        </v-layout>
      </v-container>

      <v-divider></v-divider>
      
      <v-container fuild class="pa-0" v-if="polygons.length">
        <v-list>
          <v-subheader>{{ $t('poligonos-guardados') }}</v-subheader>
          <v-list-tile v-for="(poly, index) in polygons" :key="index">
            <v-list-tile-avatar>
              <vector-polygon-icon style="font-size: 24px;"></vector-polygon-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{poly.name}}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn @click="deletePolygon(index)" icon>
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-container>

    </v-navigation-drawer>
  </main>
</template>


<script>
import AppDrawFeature from './utils/shared-components/draw-feature'
import AppSelectDrawMode from './utils/shared-components/select-draw-mode'

import VectorLayer from 'ol/layer/vector'
import VectorSource from 'ol/source/vector'

import SourceTileWMS from 'ol/source/tilewms'
import Tile from 'ol/layer/tile'

import { showStyle } from './utils/style'

const LayerShow = new VectorLayer({ source: new VectorSource, style: showStyle })
const LayerPlaneamiento = new Tile({
  opacity: 0.5,
  source: new SourceTileWMS({
    url: 'https://geoserver.greenurbandata.com/geoserver/elda/wms',
    params: {
      LAYERS: 'planeamiento'
    }
  })
})

export default {
  props: ['map'],

  components: {
    AppDrawFeature,
    AppSelectDrawMode
  },

  data() {
    return {
      id: 'Create-Search-Polygon',
      isDrawing: false,
      featureName: null,
      feature: null,
      mode: null,
    }
  },

  methods: {

    onDrawModeChange(mode) {
      this.mode = mode

      if(this.isActive) {
        this.isDrawing = true
      }
    },

    checkControl(newControl, lastControl) {
      return newControl.startsWith(this.id) || lastControl.startsWith(this.id)
    },
    
    setDrawing(bool) {
      this.isDrawing = bool
    },

    savePolygon() {
      this.feature.name = this.featureName
      this.$store.dispatch('addPolygon', this.feature)
      this.$nextTick(() => {
        this.feature = null
        this.featureName = null
        LayerShow.getSource().clear()
        this.setDrawing(true)
      })
      
    },

    discardPolygon() {
      this.feature = this.featureName = null
      this.setDrawing(false)
      LayerShow.getSource().clear()
      this.setDrawing(true)
    },

    deletePolygon(index) {
      // console.log('Delete Polygon')
      this.$store.dispatch('deletePolygon', index)
    },

    onDrawEnd(feature) {
      //console.log('drawend', feature.getGeometry().getCoordinates())
      this.feature = { coordinates: feature.getGeometry().getCoordinates() }
      this.isDrawing = false

      feature.setStyle(showStyle)
      LayerShow.getSource().addFeature(feature)
    },

    drawPolygon() {
      this.mode = 'Polygon'
      this.setDrawing(true)
    },

    drawRectangle() {
      this.mode = 'Circle'
      this.setDrawing(true)
    }
  },


  computed: {
    activeControlId() {
      return this.$store.getters.activeControlId
    },
    
    isActive() {
      return (!!this.activeControlId) && this.activeControlId.startsWith(this.id)
    },

    polygons() {
      return this.$store.getters.savedPolygons
    },

    formHasErrors() {
      const repeated = !!this.polygons.find(({name}) => name == this.featureName)
      const filled = !!this.featureName

      return !(filled && !repeated)
    }

  },

  watch: {
    activeControlId(newControl, lastControl) {
      if(!this.checkControl(newControl || '', lastControl || '')) {
        return
      }

      LayerShow.getSource().clear()
      LayerShow.setMap(this.isActive ? this.map : null)

      LayerPlaneamiento.setMap(this.isActive ? this.map : null)

      this.isDrawing = this.isActive
      this.isActive && this.$parent.fitIntoProjectExtent()
      
      this.feature = null
    },

    isDrawing(drawing) {
      drawing && LayerShow.getSource().clear()
    },

    feature() {
      this.$refs.polyname.validate(true)
    },

    featureName() {
      this.$refs.polyname.validate(true)
    }

  }
}
</script>



// WEBPACK FOOTER //
// SaveSearchPolygon.vue?27d7c3d5